'use strict';

module.exports = {
    LANG: 'ar-ma',
    SIGN: 'تسجيل الدخول',
    REGISTER: 'التسجيل',
    QUICK_ACCESS: 'الوصول السريع مع',
    SIGN_JOIN: 'اشترك أو انضم مجانًا!',
    NOT_MEMBER: 'لست عضوًا؟',
    ALREADY_MEMBER: 'هل أنت عضوًا بالفعل في AliExpress/Alibba؟',
    SHOW_ALL: 'تظهر جميع',
    HIDE: 'اخفاء'
};